import React from 'react';
import { inject, observer } from 'mobx-react';
import { Button, IButtonButtonProps } from 'telia-front-react';
import SsoStore from '../stores/SsoStore';
import GaHelper from '../util/GaHelper';

type LogInButtonProps = IButtonButtonProps & {
  ssoStore?: SsoStore;
  text: string;
  hard?: boolean;
  url: string;
  submitDataGa?: GaData;
};

@observer
class LoginButton extends React.Component<LogInButtonProps> {
  public static defaultProps: Partial<LogInButtonProps> = {
    hard: false
  };

  private handleClick = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    event.preventDefault();
    const { ssoStore, hard, url, submitDataGa, onClick } = this.props;

    if (onClick) {
      onClick(event);
    }

    GaHelper.pushGaData(submitDataGa);
    return hard ? ssoStore.ensureHardLogin(url) : ssoStore.ensureLogin(url);
  };

  private loginLevelSufficient() {
    const ssoStore = this.props.ssoStore;
    return this.props.hard ? ssoStore.loggedInWithHardAuth : ssoStore.loggedIn;
  }

  public render() {
    if (!this.props.url && this.loginLevelSufficient()) {
      return null;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { ssoStore, hard, submitDataGa, ...rest } = this.props;

    return <Button {...rest} onClick={this.handleClick} />;
  }
}

export default inject('ssoStore')(LoginButton);
